export default __webpack_public_path__ + "static/media/welcome-male.aeec8df0.png";